module.exports = __webpack_public_path__ + "img/charger-icon.d8b453f4.svg";